export const isString = (value: unknown): value is string =>
  typeof value === 'string';
export const isObject = (obj: unknown): obj is Record<string, unknown> =>
  obj === Object(obj);
